/**
 * Device Service
 * 
 * Service สำหรับจัดการข้อมูลอุปกรณ์และประวัติการ login
 */

import { callCloudFunction } from '@/services/adapters/parse/parse-client';
import type { UserDevice, LoginHistory } from './device.types';

export class DeviceService {
  /**
   * ดึงรายการอุปกรณ์ของผู้ใช้
   */
  static async getUserDevices(
    sessionToken: string,
    userId?: string,
    options?: {
      limit?: number;
      includeBlocked?: boolean;
    }
  ): Promise<UserDevice[]> {
    try {
      const result = await callCloudFunction(
        'getUserDevices',
        {
          userId: userId || undefined,
          limit: options?.limit || 50,
          includeBlocked: options?.includeBlocked || false,
        },
        sessionToken
      );

      return result || [];
    } catch (error) {
      console.error('❌ [DeviceService] getUserDevices failed:', error);
      throw error;
    }
  }

  /**
   * ดึงประวัติการ login
   */
  static async getLoginHistory(
    sessionToken: string,
    userId?: string,
    options?: {
      limit?: number;
      includeFailed?: boolean;
    }
  ): Promise<LoginHistory[]> {
    try {
      const result = await callCloudFunction(
        'getLoginHistory',
        {
          userId: userId || undefined,
          limit: options?.limit || 50,
          includeFailed: options?.includeFailed || false,
        },
        sessionToken
      );

      return result || [];
    } catch (error) {
      console.error('❌ [DeviceService] getLoginHistory failed:', error);
      throw error;
    }
  }

  /**
   * อนุมัติอุปกรณ์ (mark as trusted)
   */
  static async trustDevice(
    sessionToken: string,
    deviceId: string
  ): Promise<void> {
    try {
      await callCloudFunction(
        'trustDevice',
        { deviceId },
        sessionToken
      );
    } catch (error) {
      console.error('❌ [DeviceService] trustDevice failed:', error);
      throw error;
    }
  }

  /**
   * บล็อกอุปกรณ์
   */
  static async blockDevice(
    sessionToken: string,
    deviceId: string
  ): Promise<void> {
    try {
      await callCloudFunction(
        'blockDevice',
        { deviceId },
        sessionToken
      );
    } catch (error) {
      console.error('❌ [DeviceService] blockDevice failed:', error);
      throw error;
    }
  }

  /**
   * ยกเลิกการบล็อกอุปกรณ์
   */
  static async unblockDevice(
    sessionToken: string,
    deviceId: string
  ): Promise<void> {
    try {
      await callCloudFunction(
        'unblockDevice',
        { deviceId },
        sessionToken
      );
    } catch (error) {
      console.error('❌ [DeviceService] unblockDevice failed:', error);
      throw error;
    }
  }
}

